import { render, staticRenderFns } from "./authorize.vue?vue&type=template&id=37d957aa&scoped=true"
import script from "./authorize.vue?vue&type=script&lang=ts"
export * from "./authorize.vue?vue&type=script&lang=ts"
import style0 from "./authorize.vue?vue&type=style&index=0&id=37d957aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d957aa",
  null
  
)

export default component.exports